import { AITag, ClickableAITag } from 'component/aitag';
import { component, componentWithVariants, demoFile, CLICK, POPUP, story, variant } from 'system/demo';

demoFile('component/aitag');

component('AITag', AITag);

componentWithVariants('ClickableAITag', ClickableAITag, {}, [
    variant(null, {}, [
        story('Show modal', [
            CLICK('ai-moderated-tag'),
            POPUP(CLICK('close-modal'))
        ])
    ])
]);
